(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('AddManagingPartnerController', AddManagingPartnerController);

    function AddManagingPartnerController(partnerIndex, partner, $translate, $uibModalInstance, $timeout, toastr, PaymentSetupService, PagarmeUtilsService) {

        var vm = this;

        vm.isNew = !partner;
        vm.occupations = PaymentSetupService.getProfessionalOccupations();
        vm.partner = partner ? partner : {};
        vm.partnerIndex = partnerIndex;
        if  (!partner) {
            vm.partner.address = {};
            vm.partner.selfDeclaredLegalRepresentative = false;
        }

        vm.addressModel = {};
        vm.partnerMonthlyIncomeDisplay = null;
        syncAddressModelFromPartner();
        syncMonetaryFromPartner();

        vm.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		}

        vm.addPartner = function () {
            syncAddressModelToPartner();
            syncMonetaryToPartner();
            var data = {
                partner: vm.partner,
                partnerIndex: vm.partnerIndex
            }
            $uibModalInstance.close({ data: data });
        }

        function syncAddressModelFromPartner() {
            vm.addressModel = PagarmeUtilsService.toAddressComponentModel(vm.partner.address);
        }

        function syncAddressModelToPartner() {
            vm.partner.address = PagarmeUtilsService.toAddressDTO(vm.addressModel, vm.partner.address);
        }

        function syncMonetaryFromPartner() {
            vm.partnerMonthlyIncomeDisplay = PagarmeUtilsService.toMonetaryDisplay(vm.partner.monthlyIncome);
        }

        function syncMonetaryToPartner() {
            vm.partner.monthlyIncome = PagarmeUtilsService.toCentsModel(vm.partnerMonthlyIncomeDisplay);
        }
    }

})();
